// Her drawings as paper cut-outs (`PaperCutout`), keyed by spread `id` (the same `id`
// as in SPREAD_SEO_DATA) — the same art as each spread's tile on the app's /spread
// home (`screens/tarot/Spread.vue`). The SEO spread page tucks it into the bottom edge
// of its hero patch; spreads without a drawing show a fan of face-down cards instead.
import type { CutoutName } from '@app/utils/paperCutouts';

export interface SpreadCutout {
  name: CutoutName;
  /** Width of the drawing as a % of its box. */
  width: number;
  /** A cropped drawing: its flat cut edge(s) must hide past the patch edge. */
  tuck?: 'bottom' | 'bottom-right';
  /** Keep the drawing's separate pieces still (paw prints) instead of bobbing. */
  still?: boolean;
}

const SPREAD_CUTOUTS: Record<string, SpreadCutout> = {
  'yes-no': { name: 'wizard_cat', width: 100, tuck: 'bottom' },
  'question-single': { name: 'paw_prints', width: 100, still: true },
  'a-or-b': { name: 'card_paws', width: 78, tuck: 'bottom' },
  love: { name: 'love_cat', width: 78 },
  financial: { name: 'rich_cat', width: 84, tuck: 'bottom' },
  destiny: { name: 'peek_cat', width: 100, tuck: 'bottom-right' },
};

/** Returns the paper cut-out for a spread id, or undefined if it has no drawing. */
export const spreadCutout = (id: string): SpreadCutout | undefined => SPREAD_CUTOUTS[id];

/** Same-origin face-down card (the deck's back) for decorative fans on the SEO pages. */
export const CARD_BACK_SRC = `${import.meta.env.BASE_URL}cards/back.webp`;
